import { ComponentPropsWithRef } from "react";
import useDevice from "../hooks/useDevice";

type GridProps = ComponentPropsWithRef<"div"> & {
    paddingX?: number,
    gap?: number,
    templateColumn?: string,
    mobileTemplateColumn?: string,
    height?: string,
};

function Grid({
    children,
    style,
    gap = 15,
    paddingX = 20,
    templateColumn = "1fr 1fr",
    mobileTemplateColumn = "1fr",
    height = "400px",
}: GridProps) {

    const device = useDevice();
    const isMobile = device !== 'desktop'
    
    return (
        <div style={{display: "grid", gridTemplateColumns: isMobile ? mobileTemplateColumn : templateColumn, gap: `${gap}px`, overflow: isMobile ? "auto" : "none", padding: `0 ${paddingX}px`, ...style}}>
            {children}
        </div>
    )
}

export default Grid;